import React, { Component } from "react";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Grid from "@material-ui/core/Grid";
import logo from "../images/logo.png";
import AdmissionContext from "../AdmissionContext";

class MaintenanceView extends Component {
  static contextType = AdmissionContext;

  componentDidMount() {}

  render() {
    return (
      <div>
        {/* title */}
        <Box display="flex" justifyContent="center" pt={2}>
          <Grid container spacing={1}>
          <Grid item xs={1} sm={2} lg={3}></Grid>
          <Grid item xs={10} sm={8} lg={6}>
              <Card
                style={{
                  border: 0,
                  // minWidth: 100,
                  // maxWidth: 600,
                }}
                variant="outlined"
              >
                <CardMedia>
                  <Box display="flex" justifyContent="center" pt={1}>
                    <div>
                      <img src={logo} alt="" />
                    </div>
                  </Box>
                </CardMedia>
                <CardContent>
                  <Typography component="div">
                    <Box
                    pt={2}
                      fontWeight={400}
                      fontSize={16}
                      //color="#388e3c"
                      color="#808080"
                      display="flex"
                      justifyContent="center"
                    >
                      ONLINE ADMISSION IS CURRENTLY
                    </Box>
                  </Typography>

                  {/* title */}
                  <Typography component="div">
                    <Box
                    pt={1}
                      fontSize={28}
                      //color="#808080"
                      color="#388e3c"
                      display="flex"
                      fontWeight={400}
                      justifyContent="center"
                          >
                      UNDER MAINTENANCE
                    </Box>
                  </Typography>

                  <Typography component="div">
                    <Box
                    pt={1}
                      fontWeight={400}
                      fontSize={16}
                      //color="#388e3c"
                      color="#808080"
                      display="flex"
                      justifyContent="center"
                    >
                      We Will be Back Shortly
                    </Box>
                  </Typography>

                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={1} sm={2} lg={3}></Grid>
          </Grid>
        </Box>
      </div>
    );
  }

  AcademicYear = () => {
    const { semester, year } = this.context;

    if (year === "") {
      return null;
    }

    var strSemester = "";
    if (semester === 1) strSemester = "1st Semester";
    if (semester === 2) strSemester = "2nd Semester";
    if (semester === 3) strSemester = "Midyear";

    return (
      <Typography component="div">
        <Box
          fontSize={14}
          color="#808080"
          display="flex"
          justifyContent="center"
        >
          ({strSemester} A.Y. {year})
        </Box>
      </Typography>
    );
  };
}

export default MaintenanceView;
